import type {
  FlightPlayerScoresFragment,
  HoleScoreFragment,
} from '../../__generated__/hooks'

export const firstName = (full: string): string => full.split(/\s+/)[0] ?? full

export const sumForHoles = (
  entry: FlightPlayerScoresFragment,
  holeNumbers: Set<number>
): number =>
  (entry.scores ?? []).reduce(
    (acc, s) =>
      holeNumbers.has(s.hole.number) && s.score != null ? acc + s.score : acc,
    0
  )

export const parForHoles = (holes: HoleScoreFragment[]): number =>
  holes.reduce((s, h) => s + h.hole.par, 0)

/** Sum of stableford points across the given holes (scored holes only). */
export const sumStablefordForHoles = (
  entry: FlightPlayerScoresFragment,
  holeNumbers: Set<number>
): number =>
  (entry.scores ?? []).reduce(
    (acc, s) =>
      holeNumbers.has(s.hole.number) && s.score != null
        ? acc + s.stablefordPoints
        : acc,
    0
  )

/**
 * Par of only the holes (within `holes`) that this player has a registered
 * score for. The to-par diff must compare gross-of-scored-holes against
 * par-of-scored-holes — using the full segment par instead makes every
 * unplayed hole subtract its par (e.g. one hole played on the front nine
 * shows −32 instead of the real to-par).
 */
export const parForScoredHoles = (
  entry: FlightPlayerScoresFragment,
  holes: HoleScoreFragment[]
): number => {
  const scored = new Set(
    (entry.scores ?? [])
      .filter((s) => s.score != null)
      .map((s) => s.hole.number)
  )
  return holes.reduce(
    (s, h) => (scored.has(h.hole.number) ? s + h.hole.par : s),
    0
  )
}
